import { KalturaPinType } from '@kaltura-ott/ott-client-types';

export enum ParentalPinType {
  adult = 'adult',
  parental = 'parental',
}

export enum PinValidateStatus {
  ok = 'ok',
  error = 'error',
}

export interface PinLimitDetails {
  limit: number;
  pinType: KalturaPinType;
  pinItemName: string;
  timeOutName: string;
  timerName: string;
}

export interface TimeOutDetails {
  pinType: KalturaPinType;
  timeOut: number;
  timeStamp: number;
  timeOutName: string;
  timerName: string;
}
